import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function NewsletterStrip({ compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/signup", { email, source: window.location.pathname });
      toast.success("You're on the list — welcome to JetsetLess.");
      setEmail("");
    } catch {
      toast.error("Signup failed — try again in a moment.");
    } finally {
      setLoading(false);
    }
  };

  if (compact) {
    return (
      <div className="border border-[#D6CFC4] bg-white p-6" data-testid="newsletter-inline">
        <div className="overline text-[#B4533C] mb-2">The JetsetLess Brief</div>
        <h3 className="font-serif text-2xl leading-tight">A weekly travel edit, in your inbox.</h3>
        <form onSubmit={submit} className="mt-4 flex gap-2">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="flex-1 border border-[#D6CFC4] bg-[#F9F9F6] px-3 py-2 text-sm focus:outline-none focus:border-[#1B3B36]"
            data-testid="newsletter-email-input"
          />
          <button
            disabled={loading}
            className="bg-[#1B3B36] text-white px-4 py-2 text-sm tracking-wide hover:bg-[#112622] transition-colors disabled:opacity-50"
            data-testid="newsletter-submit-btn"
          >
            {loading ? "…" : "Subscribe"}
          </button>
        </form>
      </div>
    );
  }

  return (
    <section className="bg-[#1B3B36] text-[#F9F9F6]" data-testid="newsletter-strip">
      <div className="container-page py-16 md:py-24 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="overline text-[#D6CFC4] mb-4">The JetsetLess Brief</div>
          <h2 className="font-serif text-4xl md:text-5xl leading-none tracking-tight">One email per week. Zero fluff.</h2>
          <p className="mt-4 text-[#D6CFC4] max-w-md">
            Our editors curate the smartest travel-hack, the best point deal, and the one card move worth making — and send it Saturday mornings.
          </p>
        </div>
        <form onSubmit={submit} className="flex gap-2 md:justify-end">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="flex-1 md:w-72 bg-transparent border-b border-[#D6CFC4] px-0 py-3 text-base text-white placeholder:text-[#D6CFC4]/60 focus:outline-none focus:border-[#B4533C]"
            data-testid="newsletter-email-hero-input"
          />
          <button
            disabled={loading}
            className="bg-[#B4533C] text-white px-6 py-3 text-sm tracking-wide hover:bg-[#8F402D] transition-colors disabled:opacity-50"
            data-testid="newsletter-submit-hero-btn"
          >
            {loading ? "…" : "Subscribe →"}
          </button>
        </form>
      </div>
    </section>
  );
}
